import React, { useEffect } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { H1 } from "../../heading";
import { ExclamationAlert } from "../../icons";
import { useModal } from "../useModal";
import { useTranslate } from "../../../context/Translate";
import { jsx as ___EmotionJSX } from "@emotion/react";
/**
 * Modal with icon and message
 */
var IconModal = _ref => {
  var {
    centerHeading = true,
    children,
    headerText: headingContent,
    hideSecondaryAction = false,
    icon = ___EmotionJSX(ExclamationAlert, {
      height: "70px",
      width: "70px"
    }),
    onClose = () => {},
    openSubscribe = () => {},
    primaryAction = () => {},
    primaryActionText,
    secondaryActionText,
    showCloseButton = true
  } = _ref;
  var {
    Modal,
    close: closeModal,
    open: openModal
  } = useModal();
  var secondaryActionClick = () => {
    onClose();
    closeModal();
  };
  var t = useTranslate();
  useEffect(() => {
    openSubscribe(openModal, closeModal);
  }, [closeModal, openSubscribe, openModal]);
  return ___EmotionJSX(Modal, {
    areButtonsCentered: !primaryAction || hideSecondaryAction,
    hideSecondaryAction: hideSecondaryAction,
    onClose: onClose,
    showCloseButton: showCloseButton
  }, ___EmotionJSX(Modal.Body, null, ___EmotionJSX(Flex, {
    flexDirection: "column",
    marginTop: "12px"
  }, ___EmotionJSX(Box, {
    margin: "0 auto 37px"
  }, icon), ___EmotionJSX(H1, {
    marginBottom: "42px",
    textAlign: centerHeading ? 'center' : 'left'
  }, t(headingContent)), ___EmotionJSX(Box, null, children))), !hideSecondaryAction && ___EmotionJSX(Modal.SecondaryButton, {
    onClick: secondaryActionClick
  }, t(secondaryActionText || 'Dismiss')), primaryAction && primaryActionText && ___EmotionJSX(Modal.PrimaryButton, {
    onClick: primaryAction
  }, t(primaryActionText)));
};
export default IconModal;